import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '/reset-pwd', component: () => import('@/views/ResetPwd'), hidden: true },
  { path: '/register', component: () => import('@/views/Register'), hidden: true },
  { path: '/impove-pwd', component: () => import('@/views/ImpovePwd'), hidden: true },
  { path: '/SSO', component: () => import('@/views/SSO/index'), hidden: true },
  // 定制单点登录
  { path: '/ExtLogin', component: () => import('@/views/ExtLogin/index'), hidden: true },
  // 匿名登录
  { path: '/anonymous/:sid/:fillScheme', component: () => import('@/views/anonymous/index'), hidden: true },
  {
    path: '/',
    component: Layout,
    redirect: 'dashboard',
    name: 'Dashboard',
    meta: { title: '首页', icon: 'dashboard', noCache: false },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'dashboard', noCache: false }
      },
      {
        // 决策
        path: 'dashboard/:decisionId',
        component: () => import('@/views/dashboard/index')
      }
    ]
  },
  // 管理
  {
    path: '',
    component: Layout,
    redirect: 'manage',
    name: 'manage',
    meta: { title: '设置', icon: 'dashboard', noCache: true },
    children: [
      {
        path: '/manage',
        component: () => import('@/views/Manage/index'),
        meta: { title: '设置', icon: 'dashboard', noCache: true }
      }
    ]
  },
  // 设置
  {
    path: '',
    component: Layout,
    redirect: 'setting',
    name: 'setting',
    meta: { title: '设置', icon: 'dashboard', noCache: true },
    children: [
      {
        path: '/setting',
        component: () => import('@/views/setting/index'),
        meta: { title: '设置', icon: 'dashboard', noCache: true }
      }
    ]
  },
  // 报表
  {
    path: '',
    component: Layout,
    redirect: 'report',
    name: 'report',
    meta: { title: 'report', icon: 'example' },
    children: [
      {
        path: '/report/:templateId/:model', // 新建
        component: () => import('@/views/Report/index.vue')
      },
      {
        name: 'reportTemplate',
        path: '/report/:templateId/:recordId/:model', // 编辑查看
        component: () => import('@/views/Report/index.vue')
      },
      {
        name: 'workflowTemplate',
        path: '/report/:templateId/:recordId/:model/:workFlow', // 流程编辑查看
        component: () => import('@/views/Report/index.vue')
      },
      {
        path: '/workFlow/:templateId/:workFlowId/:model', // 新建
        component: () => import('@/views/Report/index.vue')
      }
      // {
      //   path: '/report/:templateId/:recordId/:model',
      //   component: () => import('@/views/report/index'),
      //   meta: { title: 'Example', icon: 'example' }
      // }
    ]
  },
  // 新建流程
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: 'workFlow',
  //   name: 'workFlow',
  //   meta: { title: 'workFlow', icon: 'example' },
  //   children: [
  //     {
  //       path: '/workFlow/:templateId/:workFlowId/:model', // 新建
  //       component: () => import('@/views/WorkFlow/createWorkFlow/index')
  //     }
  //   ]
  // },
  // 待办
  {
    path: '',
    component: Layout,
    redirect: 'todoWorkFlow',
    name: 'todoWorkFlow',
    meta: { title: 'todoWorkFlow' },
    children: [
      {
        path: '/todoWorkFlow',
        component: () => import('@/views/WorkFlow/todoWorkFlow/index')
      }
    ]
  },
  // 已办
  {
    path: '',
    component: Layout,
    redirect: 'doneWorkFlow',
    name: 'doneWorkFlow',
    meta: { title: 'doneWorkFlow' },
    children: [
      {
        path: '/doneWorkFlow',
        component: () => import('@/views/WorkFlow/doneWorkFlow/index')
      }
    ]
  },
  // 提交未处理
  {
    path: '',
    component: Layout,
    redirect: 'unprocessedWorkFlow',
    name: 'unprocessedWorkFlow',
    meta: { title: 'unprocessedWorkFlow' },
    children: [
      {
        path: '/unprocessedWorkFlow',
        component: () => import('@/views/WorkFlow/unprocessedWorkFlow/index')
      }
    ]
  },
  // 流程管理
  {
    path: '',
    component: Layout,
    redirect: 'allWorkFlow',
    name: 'allWorkFlow',
    meta: { title: 'allWorkFlow' },
    children: [
      {
        path: '/allWorkFlow',
        component: () => import('@/views/WorkFlow/allWorkFlow/index')
      }
    ]
  },
  // 流程
  {
    path: '',
    component: Layout,
    redirect: 'workFlow',
    name: 'workFlow',
    meta: { title: 'workFlow' },
    children: [
      {
        path: '/workFlow',
        component: () => import('@/views/WorkFlow/index')
      }
    ]
  },
  // 历史记录
  {
    path: '',
    component: Layout,
    redirect: 'preview',
    name: 'preview',
    meta: { title: 'preview', icon: 'example' },
    children: [
      {
        path: '/preview/:templateId/:type',
        component: () => import('@/views/preview/index')
      }
    ]
  },

  { path: '*', redirect: '/404', hidden: true },
  { path: '/License', component: () => import('@/views/License/index'), hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  base: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
